module.exports = __webpack_public_path__ + "img/bquiklogo-color.31548b62.svg";